export default "__VITE_ASSET__DVLJzqmo__"